import { useQueryFetch } from 'sonata-react-components';

import { getLineItems } from '@/services/lineItem.service';

import type { LineItem } from 'sonata-static-storage/lib/entities';

export type LineItemSchedule = Pick<LineItem, '_id' | 'beginDate' | 'endDate' | 'name'>;

const NO_LINE_ITEMS: LineItemSchedule[] = [];
// ponytail: one page; an IO with more line items than this would lose the rest in the flight calendar
const MAX_LINE_ITEMS = '1000';

/**
 * Schedules of the (non-deleted) line items of an insertion order, sorted by `_id` (= creation order) so each
 * line item keeps the same palette colour between visits.
 */
export function useIoLineItemSchedules(userId: string, insertionOrderId: string, enabled: boolean) {
  const { data } = useQueryFetch<LineItemSchedule[]>(
    ['ioLineItemSchedules', insertionOrderId],
    async () => {
      const { items } = await getLineItems(userId, {
        fields: ['name', 'beginDate', 'endDate'],
        fieldsOnly: true,
        insertionOrders: insertionOrderId,
        itemsPerPage: MAX_LINE_ITEMS,
        page: '1'
      });
      return items
        .map(({ _id, beginDate, endDate, name }) => ({ _id, beginDate, endDate, name }))
        .sort((a, b) => String(a._id).localeCompare(String(b._id)));
    },
    // the app QueryClient defaults to staleTime: Infinity; line items change elsewhere, so refetch on every mount
    { enabled, staleTime: 0 }
  );

  return data ?? NO_LINE_ITEMS;
}
